import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-menu-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div
        class="py-4 px-5 flex flex-row items-center justify-between cursor-pointer duration-300 transition-colors"
        [class]="stateClass().main"
        (click)="emitClick()"
      >
        <span class="duration-300 transition-all">
          {{ t(preheader() ? preheader()! : '') }}
          {{ preheader() ? '/' : '' }}
          {{ t(header()!) }}
        </span>
        @if (context()) {
          <span class="bg-error px-2.5 rounded-full text-white text-xxs">
            {{ context()! }}
          </span>
        }
      </div>
    </ng-container>
  `,
})
export class MenuItemComponent {
  protected readonly stateClasses = {
    active: {
      main: 'bg-blue-light-2 font-bold',
    },
    default: {
      main: 'text-neutral-8 hover:text-black hover:bg-neutral-3',
    },
  };

  header = input<string>();
  preheader = input<string>();
  active = input<boolean>(false);
  context = input<number>();

  onClick = output<void>();

  stateClass = computed(() => this.getStateClass(this.active()));

  emitClick() {
    this.onClick.emit();
  }

  private getStateClass(active: boolean) {
    const state = active ? 'active' : 'default';
    return this.stateClasses[state];
  }
}
